/* eslint-disable import/first */

// #region ##################################################################################### BACKGROUND
// #endregion

// #region ##################################################################################### SHAPE
// #endregion

// #region ##################################################################################### ICON
import logo_org from "theme/images/general/rsalogo.png";
// import logo_svg from "theme/images/general/rsalogo.svg";
// #endregion

// #region ##################################################################################### MISC
// #endregion

// #region ##################################################################################### PRINT
import santuario_bautizos from "theme/images/santuario-guadalupano/bautizos.jpg";
import santuario_comuniones from "theme/images/santuario-guadalupano/comuniones.jpg";
import santuario_confirmaciones from "theme/images/santuario-guadalupano/confirmaciones.jpg";
import santuario_matrimonios from "theme/images/santuario-guadalupano/matrimonios.jpg";
// #endregion

/** Objeto **I**mage**P**rovider que almacena todas las rutas de todas las imágenes y contenido de la aplicación. */
const IP = {
  _print: {
    "santuario-guadalupano": {
      bautizos: santuario_bautizos,
      comuniones: santuario_comuniones,
      confirmaciones: santuario_confirmaciones,
      matrimonios: santuario_matrimonios,
    },
  },

  /** Imágenes utilizadas como **fondo de pantalla** (imágenes grandes). */
  bg: {},

  /** Imágenes utilizadas como **contenido** (imágenes medianas). */
  shape: {},

  /** Imágenes utilizadas como **íconos** (imágenes pequeñas). */
  icon: {},

  /** Imágenes sin categoría utilizadas en ocasiones específicas. */
  misc: {
    logo_org,
  },
};

export default IP;
